export default function BannerItemSkeleton() {
  return (
    <div className="relative w-72 bg-white rounded-2xl shadow-md flex-shrink-0 overflow-hidden animate-pulse">
      <div className="h-44 w-full bg-gray-200" />
      <div className="h-20 px-3 py-3">
        <div className="h-4 w-5/6 bg-gray-200 rounded mb-2" />
        <div className="h-4 w-3/4 bg-gray-200 rounded" />
      </div>
    </div>
  );
}
